<template>
  <modal
    name="editCamposSistema"
    height="auto"
    width="1100"
    :clickToClose="false"
  >
    <CloseModal :close="close" />

    <div class="modalbox">
      <div class="modalbox-content">
      <div class="cf-header">
        <span class="cf-entidade">{{ entidade.titulo }}</span>
        <fa-icon icon="chevron-right" class="cf-sep" />
        <span class="cf-contexto">{{ contexto.titulo }}</span>
      </div>

      <div class="cf-aviso">
        <fa-icon icon="exclamation-triangle" />
        <template v-if="entidade.chave === 'cliente'">
          Esta configuração só se aplica a clientes no modo de cadastro <strong>Customizado</strong>.
        </template>
        <template v-else-if="entidade.chave === 'revendedor'">
          Esta configuração se aplica ao <strong>cadastro público de revendedor</strong> (VersoCommerce).
        </template>
        <template v-else>
          Esta configuração se aplica ao cadastro de <strong>{{ entidade.titulo }}</strong>.
        </template>
      </div>

      <!-- Pills Call Center / Força de Vendas — apenas para cadastro de cliente.
           Cada sistema tem configuração independente pós-migração (DEV-7416). -->
      <div v-if="entidade.chave === 'cliente'" class="cf-sistemas">
        <button
          class="cf-sistema-pill"
          :class="{ 'cf-sistema-pill--ativo': sistema === 'CALLCENTER' }"
          @click="$emit('sistema-changed', 'CALLCENTER')"
        >Call Center</button>
        <button
          class="cf-sistema-pill"
          :class="{ 'cf-sistema-pill--ativo': sistema === 'FORCA_VENDAS' }"
          @click="$emit('sistema-changed', 'FORCA_VENDAS')"
        >Força de Vendas</button>
      </div>

      <CTabs variant="tabs" class="nav-tabs-boxed cf-tabs">
        <CTab title="Campos do sistema" active>
      <!-- Configurações gerais do formulário (valem pro cadastro inteiro, não por-campo).
           Só aparece se a entidade tem schema próprio OU é cliente/revendedor (que têm
           consulta à Receita). Entidades sem config de formulário (ex.: contato) não exibem. -->
      <div class="cf-config-form" v-if="(configFormSchema && configFormSchema.length) || ['cliente', 'revendedor'].includes(entidade.chave)">
        <div class="cf-config-titulo">Configurações gerais do formulário</div>
        <!-- Controles dirigidos pelo schema da entidade (config_form_schema). Cada
             entidade declara seus settings no registry — sem hardcode por entidade.
             Fallback: sem schema (ex.: cliente), mantém os 2 controles atuais idênticos. -->
        <div class="cf-config-itens" v-if="configFormSchema && configFormSchema.length">
          <label class="cf-config-item" v-for="item in configFormSchema" :key="item.chave">
            <template v-if="item.tipo === 'toggle'">
              <toggle-button
                :value="!!localConfigForm[item.chave]"
                :sync="true"
                :width="36"
                :height="22"
                @change="(e) => setConfigForm(item.chave, e.value)"
              />
              <span>{{ item.label }}</span>
            </template>
            <template v-else-if="item.tipo === 'select'">
              <span>{{ item.label }}</span>
              <select v-model="localConfigForm[item.chave]" class="form-control cf-config-select">
                <option v-for="(rotulo, val) in item.opcoes" :key="val" :value="val">{{ rotulo }}</option>
              </select>
            </template>
            <template v-else>
              <span>{{ item.label }}</span>
              <input type="text" class="form-control cf-config-select" v-model="localConfigForm[item.chave]" />
            </template>
          </label>
        </div>
        <div class="cf-config-itens" v-else>
          <label class="cf-config-item">
            <toggle-button
              :value="!!localConfigForm.travar_dados_receita"
              :sync="true"
              :width="36"
              :height="22"
              @change="(e) => setConfigForm('travar_dados_receita', e.value)"
            />
            <span>Travar dados preenchidos pela Receita (somente leitura após importar)</span>
          </label>
          <label class="cf-config-item">
            <span>Consulta do CNPJ na Receita</span>
            <select v-model="localConfigForm.consulta_cnpj" class="form-control cf-config-select">
              <option value="desativada">Desativada</option>
              <option value="opcional">Opcional (botão manual)</option>
              <option value="automatica">Automática (ao preencher o CNPJ)</option>
              <option value="obrigatoria">Obrigatória (exige importar antes de prosseguir)</option>
            </select>
          </label>
        </div>
      </div>

      <div class="listagem__filtros">
        <div class="search-wrapper" style="width: 280px">
          <input
            type="text"
            class="form-control"
            v-model="busca"
            placeholder="Buscar por..."
            style="height: 38px; padding-right: 35px"
          />
          <img
            class="search-icon"
            src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNTYuOTY2IDU2Ljk2NiIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxwYXRoIGQ9Ik01NS4xNDYsNTEuODg3TDQxLjU4OCwzNy43ODZjMy40ODYtNC4xNDQsNS4zOTYtOS4zNTgsNS4zOTYtMTQuNzg2YzAtMTIuNjgyLTEwLjMxOC0yMy0yMy0yM3MtMjMsMTAuMzE4LTIzLDIzczEwLjMxOCwyMywyMywyM2M0Ljc2MSwwLDkuMjk4LTEuNDM2LDEzLjE3Ny00LjE2MmwxMy42NjEsMTQuMjA4YzAuNTcxLDAuNTkzLDEuMzM5LDAuOTIsMi4xNjIsMC45MmMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxN3MtMTctNy42MjYtMTctMTdTMTQuNjEsNiwyMy45ODQsNnoiIGZpbGw9IiMwMDQxNmYiLz4KPC9zdmc+Cg=="
          />
        </div>
        <select class="form-control listagem__select" v-model="secaoFiltro">
          <option value="">Todas as seções</option>
          <option v-for="s in secoesFiltro" :key="s.value" :value="s.value">{{ s.label }}</option>
        </select>

        <!-- Padrão único (ex.: revendedor) → botão; vários níveis (ex.: cliente) → select -->
        <CButton
          v-if="presets.length === 1"
          color="primary"
          variant="outline"
          class="cf-preset-acao"
          @click="confirmarPreset(presets[0])"
        >
          Aplicar modelo padrão
        </CButton>
        <CDropdown
          v-else-if="presets.length > 1"
          placement="bottom-end"
          add-toggler-classes="btn-outline-primary"
          toggler-text="Aplicar modelo padrão"
          class="cf-preset-acao"
        >
          <CDropdownItem
            v-for="p in presets"
            :key="p.key"
            @click="confirmarPreset(p)"
          >
            {{ p.nome }}
          </CDropdownItem>
        </CDropdown>
      </div>

        <table class="cf-table">
          <thead>
            <tr>
              <th>Campo / Rótulo</th>
              <th class="cf-center">Visível</th>
              <th class="cf-center">Obrigatório</th>
              <th>Regras</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="campo in camposFiltrados">
              <tr :key="campo.campo">
                <td>
                  <div class="cf-campo-label">
                    <input
                      type="text"
                      class="form-control cf-label-input"
                      v-model="campo.label"
                      :placeholder="campo.campo"
                      maxlength="60"
                      title="Rótulo exibido ao operador (vazio = padrão do sistema)"
                    />
                    <fa-icon
                      v-if="campo.ajuda"
                      icon="info-circle"
                      class="cf-info"
                      v-c-tooltip="{ content: campo.ajuda, placement: 'right' }"
                    />
                    <span
                      v-if="campo.estrutural"
                      class="cf-badge-sistema"
                      v-c-tooltip="{
                        content:
                          'Campo obrigatório do sistema: sempre visível e obrigatório (integração mínima). Você pode renomear e reordenar; visível e obrigatório ficam travados. Regras só mudam o rótulo — ocultar/opcional/desabilitar não afetam um campo de sistema.',
                        placement: 'right',
                      }"
                    >
                      <fa-icon icon="lock" /> sistema
                    </span>
                    <span
                      v-if="campo.vinculadoA"
                      class="cf-badge-sistema cf-badge-vinculo"
                      v-c-tooltip="{
                        content:
                          'Vinculado a ' + vinculoLabel(campo) + ': não aparece na aba Layout — renderiza grudado nesse campo no cadastro e segue a visibilidade dele. Aqui você ainda pode escondê-lo ou renomeá-lo.',
                        placement: 'right',
                      }"
                    >
                      🔗 vinculado
                    </span>
                    <fa-icon
                      v-if="(campo.regras || []).length"
                      icon="list-alt"
                      class="cf-info cf-regras-info"
                      v-c-tooltip="{ content: textoRegras(campo), placement: 'right' }"
                    />
                  </div>
                  <div class="cf-campo-secao">{{ campo.secao }} · {{ campo.campo }}</div>
                </td>
                <td class="cf-center">
                  <toggle-button
                    :value="!!campo.visivel"
                    :sync="true"
                    :width="36"
                    :height="22"
                    :disabled="!!campo.estrutural"
                    @change="(e) => (campo.visivel = e.value)"
                  />
                </td>
                <td class="cf-center">
                  <!-- Anexos (upload): a obrigatoriedade é por TIPO (mínimo de arquivos em
                       cada slot), não no geral — o toggle geral seria inócuo. -->
                  <span
                    v-if="campo.tipo === 'upload'"
                    class="cf-por-tipo"
                    v-c-tooltip="{
                      content:
                        'A obrigatoriedade dos anexos é definida por tipo (mínimo de arquivos em cada tipo), na aba Tipos de anexo.',
                      placement: 'top',
                    }"
                  >por tipo</span>
                  <toggle-button
                    v-else
                    :value="!!campo.obrigatorio"
                    :sync="true"
                    :width="36"
                    :height="22"
                    :disabled="!!campo.estrutural"
                    @change="(e) => (campo.obrigatorio = e.value)"
                  />
                </td>
                <td>
                  <CButton
                    size="sm"
                    color="primary"
                    :variant="(campo.regras || []).length ? null : 'outline'"
                    :title="campo.estrutural
                      ? 'Campo do sistema: visível+obrigatório são garantidos. Regras só mudam o rótulo (renomear por condição) — ocultar/opcional/desabilitar não têm efeito aqui.'
                      : 'Regras condicionais do campo'"
                    @click="toggleRegras(campo)"
                  >
                    <fa-icon :icon="expandido === campo.campo ? 'chevron-up' : 'plus'" />
                    {{ (campo.regras || []).length ? `${campo.regras.length} regra(s)` : 'Regra' }}
                  </CButton>
                  <CButton
                    v-if="campo.slots && campo.slots.length"
                    size="sm"
                    color="primary"
                    variant="outline"
                    class="ml-1"
                    @click="toggleSlots(campo)"
                  >
                    <fa-icon
                      :icon="expandidoSlots === campo.campo ? 'chevron-up' : 'paperclip'"
                    />
                    Tipos de anexo
                  </CButton>
                </td>
              </tr>
              <tr
                v-if="expandido === campo.campo"
                :key="campo.campo + '-regras'"
                class="cf-regras-row"
              >
                <td colspan="4">
                  <!-- Máx. de caracteres (DEV-9096): editado junto das regras do campo, mas
                       NÃO é regra condicional — persiste na coluna tamanho_maximo (só campos
                       textuais têm teto; a elegibilidade vem do servidor). -->
                  <div v-if="campo.tamanhoMaximoTeto" class="cf-tamanho-painel">
                    <label class="cf-tamanho-label" :for="'cf-tamanho-' + campo.campo">
                      Máx. de caracteres
                    </label>
                    <input
                      :id="'cf-tamanho-' + campo.campo"
                      type="number"
                      class="form-control cf-tamanho-input"
                      :value="campo.tamanhoMaximo"
                      :min="1"
                      :max="campo.tamanhoMaximoTeto"
                      :placeholder="'máx. ' + campo.tamanhoMaximoTeto"
                      :title="'Quantidade máxima de caracteres do campo no cadastro. Limite: ' + campo.tamanhoMaximoTeto + '. Vazio = padrão do sistema.'"
                      @input="setTamanhoMaximo(campo, $event.target.value)"
                    />
                    <span class="cf-tamanho-hint">
                      aplicado na digitação (Call/FV) e na gravação · até {{ campo.tamanhoMaximoTeto }} · vazio = padrão do sistema
                    </span>
                  </div>
                  <RegraCondicionalBuilder
                    :campo="campo"
                    :gatilhos="gatilhos"
                    :modelos="modelos"
                    :somenteRotular="!!campo.estrutural"
                    @input="(regras) => onRegrasChange(campo, regras)"
                    @salvar-modelo="(regra) => onSalvarModelo(regra)"
                  />
                </td>
              </tr>
              <tr
                v-if="expandidoSlots === campo.campo && campo.slots"
                :key="campo.campo + '-slots'"
                class="cf-regras-row"
              >
                <td colspan="4">
                  <div class="cf-slots-head">
                    <span class="cf-slots-info">
                      Tipos de anexo — todos vão pro mesmo armazenamento (distinguíveis por
                      tipo). Defina nome, orientação, grupo, tipos aceitos e quantidade
                      mín/máx (máx vazio = ilimitado). Mín ≥ 1 = obrigatório.
                    </span>
                    <CButton
                      size="sm"
                      color="secondary"
                      variant="outline"
                      @click="aplicarPadraoSlots(campo)"
                    >
                      Aplicar padrão
                    </CButton>
                  </div>

                  <div v-for="(slot, idx) in campo.slots" :key="slot.chave" class="cf-slot-card">
                    <div class="cf-slot-linha">
                      <span class="cf-slot-pos">{{ idx + 1 }}</span>
                      <span class="cf-slot-mover">
                        <button
                          type="button"
                          class="cf-mini-btn"
                          :disabled="idx === 0"
                          @click="moverSlot(campo, idx, -1)"
                        >▲</button>
                        <button
                          type="button"
                          class="cf-mini-btn"
                          :disabled="idx === campo.slots.length - 1"
                          @click="moverSlot(campo, idx, 1)"
                        >▼</button>
                      </span>
                      <input
                        type="text"
                        class="form-control cf-slot-input"
                        v-model="slot.label"
                        placeholder="Nome do anexo"
                        maxlength="60"
                      />
                      <input
                        type="text"
                        class="form-control cf-slot-grupo-input"
                        v-model="slot.grupo"
                        placeholder="Grupo"
                        maxlength="40"
                      />
                      <label class="cf-slot-toggle">
                        <toggle-button
                          :value="!!slot.visivel"
                          :sync="true"
                          :width="36"
                          :height="22"
                          @change="(e) => (slot.visivel = e.value)"
                        />
                        Visível
                      </label>
                      <button
                        type="button"
                        class="cf-slot-remover"
                        title="Remover tipo de anexo"
                        @click="removerSlot(campo, idx)"
                      >
                        <fa-icon icon="times" />
                      </button>
                    </div>
                    <div class="cf-slot-linha">
                      <input
                        type="text"
                        class="form-control cf-slot-input"
                        v-model="slot.orientacao"
                        placeholder="Orientação ao operador (opcional)"
                        maxlength="160"
                      />
                      <label class="cf-slot-qtd">
                        Mín
                        <input type="number" min="0" class="form-control" v-model.number="slot.min" />
                      </label>
                      <label class="cf-slot-qtd">
                        Máx
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          :value="slot.max == null ? '' : slot.max"
                          placeholder="∞"
                          @change="(e) => setMaxSlot(slot, e.target.value)"
                        />
                      </label>
                    </div>
                    <div class="cf-slot-linha cf-tipos-linha">
                      <span class="cf-tipos-label">Tipos aceitos</span>
                      <div class="cf-tipos">
                        <button
                          v-for="t in tiposChips(slot)"
                          :key="t"
                          type="button"
                          class="cf-tipo-chip"
                          :class="{ 'cf-tipo-on': (slot.tipos || []).includes(t) }"
                          @click="toggleTipo(slot, t)"
                        >
                          {{ t }}
                        </button>
                        <select
                          v-if="opcoesExtras(slot).length"
                          class="cf-tipo-add-select"
                          title="Adicionar tipo (somente extensões seguras)"
                          @change="addTipoExtra(slot, $event)"
                        >
                          <option value="">+ mais opções</option>
                          <option
                            v-for="ext in opcoesExtras(slot)"
                            :key="ext"
                            :value="ext"
                          >{{ ext }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="cf-slot-regras">
                      <button
                        type="button"
                        class="cf-slot-regra-btn"
                        :class="{ 'cf-slot-regra-ativa': (slot.regras || []).length }"
                        @click="toggleSlotRegra(slot)"
                      >
                        <fa-icon
                          :icon="slotRegraExpandida === slot.chave ? 'chevron-up' : 'sliders-h'"
                        />
                        Quantidade condicional{{
                          (slot.regras || []).length ? ` (${slot.regras.length})` : ''
                        }}
                      </button>
                      <div
                        v-if="slotRegraExpandida === slot.chave"
                        class="cf-slot-regra-area"
                      >
                        <RegraCondicionalBuilder
                          :campo="slot"
                          :gatilhos="gatilhos"
                          modo="quantidade"
                          @input="(regras) => onRegrasSlotChange(slot, regras)"
                        />
                      </div>
                    </div>
                  </div>

                  <CButton
                    size="sm"
                    color="primary"
                    variant="outline"
                    class="mt-2"
                    @click="adicionarSlot(campo)"
                  >
                    <fa-icon icon="plus" /> Adicionar tipo de anexo
                  </CButton>
                </td>
              </tr>
            </template>
            <tr v-if="!camposFiltrados.length">
              <td colspan="4" class="cf-vazio">Nenhum campo encontrado para "{{ busca }}".</td>
            </tr>
          </tbody>
        </table>
        </CTab>

        <CTab title="Layout">
          <PreviewLayout
            :campos="localCampos"
            :secoes="localSecoes"
            :gatilhos="gatilhos"
            :modelos="modelos"
            :presets="presets"
            @renomear-secao="renomearSecao"
            @adicionar-secao="adicionarSecao"
            @remover-secao="removerSecao"
            @mover-secao="moverSecao"
            @editar-regras-secao="onEditarRegrasSecao"
            @salvar-modelo="onSalvarModelo"
            @aplicar-layout-padrao="aplicarLayoutPadrao"
          />
        </CTab>

        <CTab title="Modelos de regra">
          <div class="cf-modelos">
            <div class="cf-modelos-info">
              Modelos de regra são <strong>globais</strong> e reutilizáveis em qualquer cadastro.
              Na aba "Campos do sistema", use <fa-icon icon="clone" /> para salvar uma regra como
              modelo e "Usar modelo" para aplicá-la. Aqui você gerencia o catálogo.
            </div>

            <div v-if="!modelos.length" class="cf-modelos-vazio">
              Nenhum modelo de regra cadastrado ainda.
            </div>

            <div v-for="m in modelos" :key="m.id" class="cf-modelo-card">
              <div class="cf-modelo-cab">
                <span class="cf-modelo-nome">{{ m.nome }}</span>
                <span class="cf-modelo-acoes">
                  <CButton size="sm" color="secondary" variant="ghost" title="Renomear" @click="renomearModelo(m)">
                    <fa-icon icon="pencil-alt" />
                  </CButton>
                  <CButton size="sm" color="danger" variant="ghost" title="Excluir" @click="excluirModelo(m)">
                    <fa-icon icon="times" />
                  </CButton>
                </span>
              </div>
              <div v-if="m.descricao" class="cf-modelo-desc">{{ m.descricao }}</div>
              <div class="cf-modelo-regra">
                <fa-icon icon="info-circle" class="cf-modelo-regra-icon" />
                {{ formatarRegra(m, gatilhos) }}
              </div>
            </div>
          </div>
        </CTab>
      </CTabs>
      </div>

      <div class="modal-footer-bar">
        <div class="footer-spacer"></div>
        <CButton variant="outline" color="secondary" @click="close">Cancelar</CButton>
        <CButton color="primary" @click="salvar">Salvar</CButton>
      </div>
    </div>
  </modal>
</template>

<script>
import clone from 'just-clone';
import CloseModal from '../../../components/CloseModal';
import RegraCondicionalBuilder from './RegraCondicionalBuilder.vue';
import PreviewLayout from './PreviewLayout.vue';
import { formatarRegra as fmtRegra, formatarRegras, tituloRegra } from '../helpers/formatarRegra';

export default {
  name: 'EditCamposSistema',
  components: { CloseModal, RegraCondicionalBuilder, PreviewLayout },
  props: {
    entidade: { type: Object, default: () => ({}) },
    contexto: { type: Object, default: () => ({}) },
    campos: { type: Array, default: () => [] },
    gatilhos: { type: Array, default: () => [] },
    presets: { type: Array, default: () => [] },
    secoes: { type: Array, default: () => [] },
    configForm: { type: Object, default: () => ({}) },
    configFormSchema: { type: Array, default: () => [] },
    modelos: { type: Array, default: () => [] },
    // sistema selecionado pela pill (CALLCENTER | FORCA_VENDAS | null=global)
    sistema: { type: String, default: null },
    close: { type: Function, required: true },
    onSubmit: { type: Function, required: true },
  },
  data() {
    return {
      localCampos: [],
      localSecoes: [],
      localConfigForm: {},
      originais: {},
      expandido: null,
      expandidoSlots: null,
      slotRegraExpandida: null,
      // ALLOWLIST de anexos: SÓ extensões benignas. `Comuns` viram chips; `Extras` ficam no
      // select "mais opções". Formatos de risco (.zip/.exe/.bat/.sh/.js/.html/...) NÃO entram
      // na lista — o admin não consegue habilitá-los (sem mais o input de texto livre).
      tiposAnexoComuns: ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx', '.xls', '.xlsx', '.csv'],
      tiposAnexoExtras: ['.heic', '.webp', '.gif', '.bmp', '.tiff', '.tif', '.txt', '.rtf', '.odt', '.ods', '.ppt', '.pptx'],
      busca: '',
      secaoFiltro: '',
    };
  },
  computed: {
    secoesFiltro() {
      const labels = {};
      this.localSecoes.forEach((s) => {
        labels[s.secao] = s.label;
      });
      const distintas = [...new Set(this.localCampos.map((c) => c.secao).filter(Boolean))];
      return distintas.map((s) => ({ value: s, label: labels[s] || s }));
    },
    camposFiltrados() {
      const termo = (this.busca || '').trim().toLowerCase();
      return this.localCampos.filter((c) => {
        if (this.secaoFiltro && c.secao !== this.secaoFiltro) return false;
        if (termo && !`${c.label} ${c.campo} ${c.secao}`.toLowerCase().includes(termo)) return false;
        return true;
      });
    },
  },
  watch: {
    campos: {
      immediate: true,
      handler(novos) {
        this.localCampos = clone(novos || []);
        this.originais = {};
        (novos || []).forEach((c) => {
          this.originais[c.campo] = JSON.stringify(c);
        });
        this.expandido = null;
        this.busca = '';
        this.secaoFiltro = '';
      },
    },
    secoes: {
      immediate: true,
      handler(novas) {
        this.localSecoes = clone(novas || []);
      },
    },
    configForm: {
      immediate: true,
      handler(cfg) {
        // Defaults seguros caso o backend ainda não tenha enviado (preserva o atual).
        this.localConfigForm = {
          travar_dados_receita: true,
          consulta_cnpj: 'opcional',
          ...clone(cfg || {}),
        };
      },
    },
  },
  methods: {
    toggleRegras(campo) {
      this.expandido = this.expandido === campo.campo ? null : campo.campo;
      this.expandidoSlots = null; // só um painel aberto por vez (evita confusão)
    },
    // $set garante reatividade ao gravar chaves novas (ex.: permite_pf) no config_form.
    setConfigForm(chave, valor) {
      this.$set(this.localConfigForm, chave, valor);
    },
    // Rótulo do campo ALVO de um vínculo (ex.: isento → "Inscrição Estadual"), p/ o badge.
    vinculoLabel(campo) {
      const alvo = this.localCampos.find((c) => c.campo === campo.vinculadoA);
      return (alvo && alvo.label) || campo.vinculadoA;
    },
    // ───── Regras (tooltip) + modelos de regra ─────
    textoRegras(campo) {
      return formatarRegras(campo.regras || [], this.gatilhos).join(' • ');
    },
    formatarRegra(regra, gatilhos) {
      return fmtRegra(regra, gatilhos);
    },
    onSalvarModelo(regra) {
      // O título do modelo é o texto humanizado da regra (sem prompt). Pode ser
      // renomeado depois na aba "Modelos de regra".
      this.$emit('criar-modelo', {
        nome: tituloRegra(regra, this.gatilhos),
        descricao: null,
        efeito: regra.efeito,
        conector: regra.conector || 'E',
        rotulo: regra.rotulo || null, // payload do efeito `rotular`
        condicoes: regra.condicoes || [],
      });
    },
    renomearModelo(m) {
      this.$swal({
        title: 'Renomear modelo',
        input: 'text',
        inputValue: m.nome,
        showCancelButton: true,
        confirmButtonText: 'Salvar',
        cancelButtonText: 'Cancelar',
        inputValidator: (v) => (!v || !v.trim() ? 'Informe um nome.' : undefined),
      }).then((r) => {
        if (!r.value) return;
        this.$emit('atualizar-modelo', { ...m, nome: r.value.trim() });
      });
    },
    excluirModelo(m) {
      this.$swal({
        title: `Excluir o modelo "${m.nome}"?`,
        text: 'Os campos que já usam essa regra não são afetados; o modelo só deixa de ficar disponível para aplicar.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      }).then((r) => {
        if (r.value) this.$emit('excluir-modelo', m);
      });
    },
    toggleSlots(campo) {
      this.expandidoSlots = this.expandidoSlots === campo.campo ? null : campo.campo;
      this.expandido = null; // só um painel aberto por vez (evita confusão)
    },
    toggleSlotRegra(slot) {
      this.slotRegraExpandida =
        this.slotRegraExpandida === slot.chave ? null : slot.chave;
    },
    onRegrasSlotChange(slot, regras) {
      this.$set(slot, 'regras', regras);
    },
    // ───────── CRUD dos slots de anexo (LP3+) ─────────
    slugSlot(label, existentes) {
      const base =
        (label || 'anexo')
          .toString()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '') || 'anexo';
      if (! existentes.includes(base)) return base;
      let i = 2;
      while (existentes.includes(`${base}_${i}`)) i += 1;
      return `${base}_${i}`;
    },
    adicionarSlot(campo) {
      if (! campo.slots) this.$set(campo, 'slots', []);
      const existentes = campo.slots.map((s) => s.chave);
      const maxOrdem = campo.slots.reduce((m, s) => Math.max(m, s.ordem || 0), 0);
      campo.slots.push({
        chave: this.slugSlot('anexo', existentes),
        label: 'Novo anexo',
        orientacao: '',
        grupo: 'Outros',
        tipos: [],
        min: 0,
        max: null,
        visivel: true,
        ordem: maxOrdem + 10,
        regras: [],
      });
    },
    removerSlot(campo, idx) {
      campo.slots.splice(idx, 1);
    },
    moverSlot(campo, idx, dir) {
      const j = idx + dir;
      if (j < 0 || j >= campo.slots.length) return;
      const arr = campo.slots;
      const tmp = arr[idx];
      arr.splice(idx, 1);
      arr.splice(j, 0, tmp);
      arr.forEach((s, i) => {
        s.ordem = (i + 1) * 10;
      });
    },
    aplicarPadraoSlots(campo) {
      this.$swal({
        title: 'Aplicar padrão?',
        text: 'Substitui os tipos de anexo pelos padrões do sistema (fachada, interior, contrato, certidão, comprador).',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aplicar',
        cancelButtonText: 'Cancelar',
      }).then((r) => {
        if (r.value) this.$set(campo, 'slots', clone(campo.slotsPadrao || []));
      });
    },
    // chips exibidos = tipos comuns + os customizados já selecionados (sem duplicar).
    tiposChips(slot) {
      return [...new Set([...this.tiposAnexoComuns, ...(slot.tipos || [])])];
    },
    toggleTipo(slot, t) {
      const sel = slot.tipos || [];
      slot.tipos = sel.includes(t) ? sel.filter((x) => x !== t) : [...sel, t];
    },
    // "mais opções": extensões benignas adicionais (allowlist) ainda não selecionadas.
    opcoesExtras(slot) {
      const sel = slot.tipos || [];
      return this.tiposAnexoExtras.filter((ext) => !sel.includes(ext));
    },
    // adiciona a extensão escolhida no select (sempre da allowlist) e volta ao placeholder.
    addTipoExtra(slot, event) {
      const ext = event.target.value;
      if (ext) this.toggleTipo(slot, ext); // opcoesExtras já exclui selecionados → toggle adiciona
      event.target.value = '';
    },
    setMaxSlot(slot, val) {
      slot.max = val === '' || val == null ? null : Number(val);
    },
    setTamanhoMaximo(campo, val) {
      campo.tamanhoMaximo = val === '' || val == null ? null : Number(val);
    },
    onRegrasChange(campo, regras) {
      this.$set(campo, 'regras', regras);
    },
    confirmarPreset(preset) {
      this.$swal({
        title: `Aplicar modelo padrão "${preset.nome}"?`,
        text: `${preset.descricao} Isso substitui as configurações dos campos (visível/obrigatório/regras) e restaura a ordem e seção de cada campo. Você ainda precisa clicar em Salvar.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aplicar',
        cancelButtonText: 'Cancelar',
      }).then((r) => {
        if (r.value) this.aplicarPreset(preset);
      });
    },
    // "Aplicar modelo": aplica GOVERNANÇA (visível/obrigatório/regras) E LAYOUT (ordem/seção).
    aplicarPreset(preset) {
      const porCampo = {};
      preset.campos.forEach((c) => {
        porCampo[c.campo] = c;
      });

      this.localCampos.forEach((campo) => {
        if (campo.estrutural) return; // piso: base forçado no backend
        const p = porCampo[campo.campo];
        if (! p) return;
        campo.visivel = p.visivel;
        campo.obrigatorio = p.obrigatorio;
        this.$set(campo, 'regras', p.regras || []);
      });

      this.aplicarLayoutPadrao(preset);
      this.expandido = null;
    },
    // Também chamado por "Aplicar layout padrão" na aba Layout (só ordem/seção, sem tocar em governança).
    aplicarLayoutPadrao(preset) {
      const porCampo = {};
      ((preset && preset.campos) || []).forEach((c) => {
        porCampo[c.campo] = c;
      });

      this.localCampos.forEach((campo) => {
        const p = porCampo[campo.campo];
        const ordem = p && p.ordem != null ? p.ordem : campo.ordemPadrao;
        const secao = p && p.secao != null ? p.secao : campo.secaoPadrao;
        if (ordem != null) this.$set(campo, 'ordem', ordem);
        if (secao != null) this.$set(campo, 'secao', secao);
      });
    },
    // ───────── CRUD de seções (aba Layout) ─────────
    // Gera uma chave estável (slug) única para uma seção nova.
    slugSecao(label) {
      // base ASCII: lowercase + tudo que não for [a-z0-9] (inclui acentos/espaços) vira "_".
      const base =
        (label || 'secao')
          .toString()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '') || 'secao';
      const existentes = new Set(this.localSecoes.map((s) => s.secao));
      if (! existentes.has(base)) return base;
      let i = 2;
      while (existentes.has(`${base}_${i}`)) i += 1;
      return `${base}_${i}`;
    },
    renomearSecao({ chave, label }) {
      const s = this.localSecoes.find((x) => x.secao === chave);
      if (s) s.label = (label || '').trim() || s.secao;
    },
    // Regras (efeito `rotular`) da seção — renomeia o nome da seção por condição.
    onEditarRegrasSecao({ chave, regras }) {
      const s = this.localSecoes.find((x) => x.secao === chave);
      if (s) this.$set(s, 'regras', regras);
    },
    adicionarSecao({ label }) {
      const chave = this.slugSecao(label);
      const maxOrdem = this.localSecoes.reduce((m, s) => Math.max(m, s.ordem ?? 0), 0);
      this.localSecoes.push({
        secao: chave,
        label: (label || '').trim(),
        ordem: maxOrdem + 10,
        custom: true,
      });
    },
    removerSecao({ chave }) {
      const alvo = this.localSecoes.find((s) => s.secao === chave);
      // só seções customizadas são removíveis; padrão (registry) reaparece do config.
      if (! alvo || ! alvo.custom || this.localSecoes.length <= 1) return;

      // reassocia os campos da seção removida à primeira seção remanescente (por ordem).
      const destino = this.localSecoes
        .filter((s) => s.secao !== chave)
        .slice()
        .sort((a, b) => (a.ordem ?? 9999) - (b.ordem ?? 9999))[0];
      if (! destino) return;

      this.localCampos.forEach((c) => {
        if (c.secao === chave) c.secao = destino.secao;
      });

      this.localSecoes = this.localSecoes.filter((s) => s.secao !== chave);
    },
    moverSecao({ chave, direcao }) {
      // troca a seção com a vizinha (cima/baixo) e renumera a ordem sequencialmente
      // (passo 10) — a posição exibida (1,2,3…) é o índice ascendente no front.
      const ordenadas = this.localSecoes
        .slice()
        .sort((a, b) => (a.ordem ?? 9999) - (b.ordem ?? 9999));
      const i = ordenadas.findIndex((s) => s.secao === chave);
      if (i === -1) return;
      const j = direcao === 'cima' ? i - 1 : i + 1;
      if (j < 0 || j >= ordenadas.length) return; // já no limite
      [ordenadas[i], ordenadas[j]] = [ordenadas[j], ordenadas[i]];
      // $set garante reatividade mesmo se algum objeto viesse sem a chave `ordem`.
      ordenadas.forEach((s, idx) => {
        this.$set(s, 'ordem', (idx + 1) * 10);
      });
    },
    salvar() {
      // envia só o delta (campos alterados em relação ao baseline carregado).
      // estruturais entram no delta só por apresentação (label/ordem): o backend força
      // a governança (visível/obrigatório/regra) e ignora o resto.
      // label em branco volta ao padrão do sistema (null = herda o baseline do registry).
      const sistemaAtual = this.sistema || '*';
      const alterados = this.localCampos
        .filter((c) => JSON.stringify(c) !== this.originais[c.campo])
        .map((c) => {
          const base = {
            ...c,
            label: (c.label || '').trim() || null,
            // chave snake explícita (o backend lê tamanho_maximo): null = sem limite.
            tamanho_maximo: c.tamanhoMaximo ?? null,
            sistema: sistemaAtual,
          };
          // LP3+: persiste a LISTA autoritativa de slots de anexo em config.slots
          // (CRUD do admin) — o catálogo segue com um único campo `upload`.
          if (c.slots) {
            base.config = {
              slots: c.slots.map((s) => ({
                chave: s.chave,
                label: (s.label || '').trim() || s.chave,
                orientacao: (s.orientacao || '').trim() || null,
                grupo: (s.grupo || '').trim() || 'Anexos',
                tipos: s.tipos || [],
                min: Number(s.min) || 0,
                max: s.max == null || s.max === '' ? null : Number(s.max),
                visivel: !!s.visivel,
                ordem: s.ordem,
                regras: s.regras || [],
              })),
            };
          }
          return base;
        });

      // Config de FORMULÁRIO (travar dados da Receita + modo de consulta do CNPJ) vai no
      // registro sentinela `campo='_form'` (config jsonb), junto no payload de campos.
      alterados.push({ campo: '_form', config: { ...this.localConfigForm }, sistema: sistemaAtual });

      // Seções: cada uma salva com o sistema selecionado (não sobrescreve o global/outros sistemas).
      const secoesComSistema = this.localSecoes.map((s) => ({ ...s, sistema: sistemaAtual }));

      this.onSubmit({ campos: alterados, secoes: secoesComSistema });
    },
  },
};
</script>

<style scoped>
.cf-config-form {
  background: #f9fafb; border: 1px solid #e4e7eb; border-radius: 8px;
  padding: 12px 16px; margin-bottom: 16px;
}
.cf-config-titulo { font-size: 13px; font-weight: 600; color: #344054; margin-bottom: 10px; }
.cf-config-itens { display: flex; flex-wrap: wrap; gap: 12px 32px; align-items: center; }
.cf-config-item { display: inline-flex; align-items: center; gap: 8px; margin: 0; min-height: 36px; font-size: 13px; line-height: 1.3; color: #475467; }
/* o toggle-button renderiza um <label> interno que herda o margin-bottom global do CoreUI,
   desalinhando-o do texto/select; zera igual ao padrao de Segmentos.vue (.usa-restricao label) */
.cf-config-item ::v-deep .vue-js-switch { margin: 0; vertical-align: middle; }
.cf-config-select { width: auto; min-width: 240px; height: 36px; display: inline-block; }
.cf-header {
  font-size: 16px; margin-bottom: 14px;
  border-bottom: 1px solid #e9ecef; padding-bottom: 12px;
}
.cf-entidade { font-weight: 700; color: #1d2939; }
.cf-sep { color: #98a2b3; margin: 0 8px; font-size: 11px; }
.cf-contexto { color: #475467; }

.cf-aviso {
  background: #fff8eb; border: 1px solid #fde8c8; color: #b54708;
  border-radius: 8px; padding: 8px 12px; font-size: 13px; margin-bottom: 16px;
}

/* a aba não é um scroller próprio — o conteúdo flui para o .modalbox-content
   (único scroller), evitando a rolagem dupla dentro do modal. `border: 0` remove a
   moldura do `.nav-tabs-boxed` (global), que com overflow visível embrulhava o conteúdo
   alto e rolava junto, aparecendo como uma "linha solta" no meio da tabela. */
.cf-tabs >>> .tab-content { padding-top: 16px; overflow: visible; border: 0; }

/* Filtros no padrão da tela de Colaboradores */
.listagem__filtros { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.search-wrapper { position: relative; display: block; }
.search-icon {
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  pointer-events: none; width: 16px; height: 16px;
}
.listagem__select { height: 38px; width: auto; min-width: 160px; }
.cf-preset-acao { margin-left: auto; }

.cf-table { width: 100%; border-collapse: collapse; }
.cf-table th {
  text-align: left; font-size: 11px; text-transform: uppercase; color: #667085;
  font-weight: 600; padding: 8px 10px; border-bottom: 2px solid #eaecf0;
  background: #fff;
}
.cf-table td { padding: 10px; border-bottom: 1px solid #f2f4f7; vertical-align: middle; }
.cf-center { text-align: center; }
.cf-table th.cf-center,
.cf-table td.cf-center { text-align: center; }
.cf-campo-label { display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: 14px; color: #344054; }
.cf-label-input { height: 32px; max-width: 260px; padding: 4px 8px; font-size: 14px; font-weight: 600; color: #344054; }
.cf-tamanho-painel { display: flex; align-items: center; gap: 10px; padding: 10px 4px 12px; border-bottom: 1px dashed #e4e7eb; margin-bottom: 10px; }
.cf-tamanho-label { font-size: 13px; font-weight: 600; color: #344054; margin: 0; }
.cf-tamanho-input { height: 32px; width: 110px; flex: 0 0 auto; padding: 4px 8px; font-size: 13px; color: #475467; }
.cf-tamanho-hint { font-size: 12px; color: #667085; }
.cf-campo-secao { font-size: 11px; color: #98a2b3; }
.cf-por-tipo {
  display: inline-block; height: 22px; line-height: 22px; vertical-align: middle;
  /* o toggle (vue-js-switch) fica ~4px acima da linha base; nudge p/ alinhar com ele */
  position: relative; top: -4px;
  font-size: 10px; font-weight: 600; color: #667085; background: #f2f4f7;
  border-radius: 11px; padding: 0 8px; cursor: help; user-select: none;
}
.cf-info { color: #98a2b3; font-size: 12px; cursor: help; }
.cf-info:hover { color: #475467; }
.cf-regras-info { color: #3538cd; }

/* Aba "Modelos de regra" */
.cf-modelos { padding: 8px 4px; }
.cf-modelos-info { font-size: 12px; color: #667085; margin-bottom: 14px; }
.cf-modelos-vazio { font-size: 13px; color: #98a2b3; padding: 16px; text-align: center; }
.cf-modelo-card { border: 1px solid #e4e7eb; border-radius: 10px; padding: 12px 14px; margin-bottom: 10px; background: #fff; }
.cf-modelo-cab { display: flex; align-items: center; justify-content: space-between; }
.cf-modelo-nome { font-weight: 600; font-size: 14px; color: #1d2939; }
.cf-modelo-acoes { display: inline-flex; gap: 4px; }
.cf-modelo-desc { font-size: 12px; color: #667085; margin-top: 2px; }
.cf-modelo-regra { margin-top: 8px; font-size: 12px; color: #475467; font-style: italic; background: #f9fafb; border-radius: 6px; padding: 6px 10px; }
.cf-modelo-regra-icon { color: #98a2b3; margin-right: 4px; }
.cf-badge-sistema {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.02em;
  color: #3538cd; background: #eef4ff; border: 1px solid #d1e0ff;
  border-radius: 10px; padding: 1px 8px; cursor: help;
}
.cf-badge-vinculo { color: #0e7090; background: #ecfdff; border-color: #a5f0fc; }
.cf-sem-regra { color: #d0d5dd; }
.cf-regras-row td { background: #f9fafb; }

/* LP3+: editor CRUD de slots de anexo */
.cf-slots-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 10px; }
.cf-slots-info { font-size: 12px; color: #667085; flex: 1; }
.cf-slot-card { border: 1px solid #e4e7eb; border-radius: 8px; padding: 8px 10px; margin-bottom: 8px; background: #fff; }
.cf-slot-linha { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.cf-slot-linha + .cf-slot-linha { margin-top: 6px; }
.cf-slot-pos {
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
  width: 20px; height: 20px; border-radius: 50%; background: #eef0f4; color: #3a3e81; font-size: 11px; font-weight: 700;
}
.cf-slot-mover { display: inline-flex; flex-direction: column; gap: 2px; flex-shrink: 0; }
.cf-mini-btn {
  border: 1px solid #d0d5dd; background: #fff; color: #475467; border-radius: 4px;
  width: 20px; height: 13px; padding: 0; cursor: pointer; font-size: 8px; line-height: 1;
  display: inline-flex; align-items: center; justify-content: center;
}
.cf-mini-btn:disabled { opacity: 0.35; cursor: not-allowed; }
.cf-slot-input { flex: 1; min-width: 150px; height: 32px; font-size: 13px; }
.cf-slot-grupo-input { width: 120px; height: 32px; font-size: 13px; }

/* Tipos de anexo: chips pré-selecionáveis + campo p/ digitar um customizado */
.cf-tipos-linha { align-items: flex-start; }
.cf-tipos-label { font-size: 12px; color: #475467; padding-top: 5px; flex-shrink: 0; }
.cf-tipos { display: flex; flex-wrap: wrap; align-items: center; gap: 4px; flex: 1; min-width: 180px; }
.cf-tipo-chip {
  border: 1px solid #d0d5dd; background: #fff; color: #667085; border-radius: 12px;
  padding: 2px 10px; font-size: 12px; line-height: 1.7; cursor: pointer;
}
.cf-tipo-chip:hover { border-color: #3538cd; color: #3538cd; }
.cf-tipo-on { background: #eef4ff; border-color: #3538cd; color: #3538cd; font-weight: 600; }
/* "pill" select "mais opções": só extensões benignas da allowlist (sem input livre). */
.cf-tipo-add-select {
  border: 1px dashed #cdd3dd; border-radius: 12px; background: #fff; color: #3538cd;
  font-size: 12px; line-height: 1.7; padding: 2px 8px; cursor: pointer;
}
.cf-tipo-add-select:hover { border-color: #3538cd; }
.cf-slot-toggle { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: #475467; margin: 0; flex-shrink: 0; }
.cf-slot-qtd { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: #475467; margin: 0; }
.cf-slot-qtd .form-control { width: 64px; height: 32px; }
.cf-slot-remover {
  border: 1px solid #fecdca; background: #fff; color: #d92d20; border-radius: 6px;
  width: 28px; height: 28px; cursor: pointer; flex-shrink: 0;
}
.cf-slot-remover:hover { background: #fef3f2; }

/* LP3+ F2: regra de quantidade condicional por slot */
.cf-slot-regras { margin-top: 6px; }
.cf-slot-regra-btn {
  border: none; background: none; color: #667085; cursor: pointer;
  font-size: 12px; font-weight: 600; padding: 2px 0; display: inline-flex; align-items: center; gap: 6px;
}
.cf-slot-regra-btn:hover { color: #3538cd; }
.cf-slot-regra-ativa { color: #3538cd; }
.cf-slot-regra-area {
  border-top: 1px dashed #e4e7eb; margin-top: 4px;
}
.cf-vazio { text-align: center; color: #98a2b3; padding: 24px; font-size: 13px; }

/* Layout robusto (não depende do :has() do CSS global): UMA rolagem só (conteúdo
   interno) + footer fixo. O modal não usa `scrollable` (overlay não rola); descontamos
   o cabeçalho do X (~48px) do teto para o modal inteiro caber no viewport sem clipar. */
.modalbox { display: flex; flex-direction: column; max-height: calc(90vh - 48px); }
.modalbox-content { flex: 1 1 auto; overflow-y: auto; min-height: 0; }

.modal-footer-bar {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 20px 0; border-top: 1px solid #e9ecef; flex-shrink: 0;
}
.footer-spacer { flex: 1; }

/* Pills Call Center / Força de Vendas */
.cf-sistemas {
  display: flex; gap: 8px; margin-bottom: 16px;
}
.cf-sistema-pill {
  padding: 6px 16px; border-radius: 20px; border: 1px solid #d0d5dd;
  background: #fff; color: #475467; font-size: 13px; font-weight: 500;
  cursor: pointer; transition: all 0.15s; line-height: 1.4;
}
.cf-sistema-pill:hover { border-color: #3a3e81; color: #3a3e81; }
.cf-sistema-pill--ativo {
  background: #3a3e81; border-color: #3a3e81; color: #fff;
}
.cf-sistema-pill--ativo:hover { background: #2e326a; border-color: #2e326a; color: #fff; }
</style>
